<div class="expanded-panel-header purple" (click)="toggleExpanded()">Credit Outlets</div>
@if(expanded){
  <div class="row">
    <table>
      <thead>
      <tr>
        <th>Type</th>
        <th>Name</th>
        <th>Close Date</th>
        <th>Credit Type</th>
        <th>Ownership</th>
        <th>Placement</th>
        <th>Admitted Date</th>
        <th>Exit Date</th>
      </tr>
      </thead>
      <tbody>
      @for(outlet of detail.outlets; track $index){
        <tr>
          <td>{{ outlet.type ?? '--' }}</td>
          <td>{{ outlet.outlet ?? '--'}}</td>
          <td>{{ outlet.close_date ? (outlet.close_date | date: 'MM/dd/yyyy') : '--'}}</td>
          <td>{{ outlet.credit_type ?? '--'}}</td>
          <td>{{ outlet.ownership ? (outlet.ownership | percent: '1.2-2') : '--'}}</td>
          <td>{{ outlet.placement_status ?? '--'}}</td>
          <td>{{ outlet.admitted_date ? (outlet.admitted_date | date: 'MM/dd/yyyy') : '--'}}</td>
          <td>{{ outlet.exit_date ? ( outlet.exit_date | date: 'MM/dd/yyyy') : '--'}}</td>
        </tr>
      }
      </tbody>
    </table>
  </div>
}
